import * as React from "react";
import { TransactionSummary } from "./transactions_summary";


export default function Transactions() {
    return (
       <TransactionSummary />
    )
}